const CryptoJS = require('crypto-js');

export const isJson = (str) => {
    try {
        let obj = JSON.parse(str);
        return !!(obj && Object.prototype.toString.call(obj) === '[object Object]');
    } catch (error) {
        return false;
    }
};

// 检查是否能被JSON.parse解析
export function isValidJSON (str) {
    try {
        JSON.parse(str);
        return true;
    } catch (error) {
        return false;
    }
}

// 将obj对象转为链接参数
export const formatQuery = (obj) => {
    let str = '';
    if (obj && JSON.stringify(obj) !== '{}') {
        for (let key in obj) {
            str += `${key}=${obj[key]}&`;
        }
        str = str.slice(0, str.length - 1);
    }
    return str;
};

// 将数组里某值用(某符号)，默认逗号拼接
export const formatListValueWidthFlag = (list, key, flag = ',') => {
    let str = '';
    for (let i = 0, len = list.length; i < len; i++) {
        str += list[i][key];
        if (i < len - 1) {
            str += flag;
        }
    }
    return str;
};

export const extractTextFromBrackets = (inputString) => {
    const regex = /\{(([a-z]+)[a-z0-9_]*)\}/ig; // 以字母开头，包含下划线，字母，数字
    // const regex = /\{((_[a-z]+)[a-z0-9_]*)\}/ig; // 以下划线和字母开头，且不能只有下划线，包含下划线，字母，数字
    const matches = [];
    let match;

    while ((match = regex.exec(inputString)) !== null) {
        matches.push(match[1]);
    }

    return matches;
};

// 深拷贝并处理不需要的项(emptyArrAsNull用来处理子项的children由数组赋值变为null赋值，一般用在叶子节点)
export function deepCloneByCondition (options = {
    obj: {},
    notNeedKeys: [],
    compareKey: '',
    emptyArrAsNull: false,
    addKeyName: '', // 需要额外添加的key值
    addKeyValue: '', // 需要额外添加的key值的赋值
    addKeyValueBy: []
    // 需要额外添加的key值的赋值来源（当addKeyValue有值的时候不取addKeyValueBy，
    // addKeyValueBy里取值为obj已有的key值）一般该key值对应的值为字符串
}) {
    let optionsDefault = {
        obj: {},
        notNeedKeys: [],
        compareKey: '',
        emptyArrAsNull: false
    };
    options = {
        ...optionsDefault,
        ...options
    };
    let { obj, notNeedKeys, compareKey, emptyArrAsNull, addKeyName, addKeyValue, addKeyValueBy } = options;
    // 当没有可处理的条件就直接原样返回
    if (!notNeedKeys.length || !compareKey) {
        if (!emptyArrAsNull) {
            return obj;
        }
    }
    if (typeof obj !== 'object' || obj === null) {
        return obj;
    }
    let res = {};
    if (obj instanceof Array) {
        if (emptyArrAsNull) {
            if (obj.length === 0) {
                return null;
            }
        }
        res = [];
    }
    let arrIndex = '##'; // 判断当前命中的项索引
    let arrIndexList = []; // 判断当前命中的项索引集合
    // 循环判断命中项是哪个
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            for (let i = 0; i < notNeedKeys.length; i++) {
                // 如果是数组类型，需要通过数组方式判断
                if (obj instanceof Array) {
                    for (let j = 0; j < obj.length; j++) {
                        if (obj[j][compareKey] === notNeedKeys[i]) {
                            arrIndex = j;
                            break;
                        }
                    }
                } else {
                    if (obj[key] === notNeedKeys[i]) {
                        arrIndex = key;
                        break;
                    }
                }
                // 如果命中
                if (arrIndex !== '##') {
                    arrIndexList.push(arrIndex);
                }
            }
        }
    }
    // 跳过命中项，其余拷贝
    for (let key in obj) {
        let toContinue = false;
        for (let j = 0; j < arrIndexList.length; j++) {
            if (arrIndexList[j] + '' === key) {
                toContinue = true;
                break;
            }
        }
        if (toContinue) {
            continue;
        }
        if (obj.hasOwnProperty(key)) {
            // 数组索引需要减一，否则会多出个empty数组元素
            let keyTem = key;
            if (!isNaN(key)) {
                keyTem = +key;
                if (+key > arrIndex) {
                    keyTem -= 1;
                }
            }
            res[keyTem] = deepCloneByCondition(
                options = {
                    obj: obj[key],
                    notNeedKeys: notNeedKeys,
                    compareKey: compareKey,
                    emptyArrAsNull: emptyArrAsNull,
                    addKeyName,
                    addKeyValue,
                    addKeyValueBy
                }
            );
        }
    }
    if (!(res instanceof Array)) {
        if (addKeyName) {
            if (addKeyValue) {
                res[addKeyName] = addKeyValue;
            } else {
                if ((addKeyValueBy instanceof Array) && addKeyValueBy.length) {
                    for (let i = 0; i < addKeyValueBy.length; i++) {
                        if (!res[addKeyName]) {
                            res[addKeyName] = '';
                        }
                        if (res[addKeyValueBy[i]]) {
                            res[addKeyName] += res[addKeyValueBy[i]];
                            if (i < (addKeyValueBy.length - 1)) {
                                res[addKeyName] += '_';
                            }
                        }
                    }
                }
            }
        }
    }
    return res;
}

// 加密方法
export function Encrypt (content, key) {
    if (!content) { return content; }
    key = CryptoJS.enc.Utf8.parse(key);
    let sContent = CryptoJS.enc.Utf8.parse(content);
    let encrypted = CryptoJS.AES.encrypt(sContent, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
}

export const Decrypt = (content, key) => {
    if (!content) {
        return content;
    }
    key = CryptoJS.enc.Utf8.parse(key);
    let decrypted = CryptoJS.AES.decrypt(content, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return decrypted.toString(CryptoJS.enc.Utf8);
};

// 字符转十六进制
export const stringsToHex = (str, format = '') => {
    let arr = [];
    for (let i = 0; i < str.length; i++) {
        arr[i] = (str.charCodeAt(i).toString(16)).slice(-4);
    }
    return format + arr.join(format);
};

/**
 * 获取页面链接参数
 * @param name 参数的key值
 */
export const getUrlParam = (name) => {
    let results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
    if (!results) {
        return '';
    }
    return results[1];
};
